var React = require('react');

function FooterLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 25c8.284 0 15 6.716 15 15h-8C6.716 40 0 33.284 0 25h8zm40 0c0 8.284-6.716 15-15 15h-8c0-8.284 6.716-15 15-15h8zM23 8c0 8.284-6.716 15-15 15H0C0 14.716 6.716 8 15 8h8zm10 0c8.284 0 15 6.716 15 15h-8c-8.284 0-15-6.716-15-15h8z","fill":"#fff"}));
}

FooterLogo.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = FooterLogo;

FooterLogo.default = FooterLogo;
